<template>
  <div>
    <v-card style="border-radius: 10px;" v-if="selectedEvent">
      <v-card-title
        :style="{
          padding: '0',
          background: selectedEvent.active
            ? 'linear-gradient(135deg, #2e7d32 0%, #4caf50 60%, #66bb6a 100%)'
            : 'linear-gradient(135deg, #546e7a 0%, #78909c 60%, #90a4ae 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }"
      >
        <div
          style="width: 100%; padding: 12px 24px; position: relative; z-index: 1;"
        >
          <v-layout row align-center class="mb-1">
            <span
              style="
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    opacity: 0.85;
                  "
            >
              Event #{{ selectedEvent.id }}
            </span>
            <v-spacer></v-spacer>
            <v-chip
              :title="
                selectedEvent.active ? 'event is active' : 'event is inactive'
              "
              small
              color="rgba(255,255,255,0.18)"
              text-color="white"

              class="ma-0"
              :style="{
                fontWeight: 600,
                letterSpacing: '0.3px',
                border: '1px solid rgba(255,255,255,0.35)',
              }"
            >

              <span style="font-weight: bold; letter-spacing: 1.5px; font-size: 12px; text-shadow: 1px 1px 0 #0002;">
                {{ selectedEvent.active ? "Active" : "Inactive" }}
              </span>

            </v-chip>
          </v-layout>

          <div
            style="
                  font-size: 22px;
                  font-weight: 600;
                  line-height: 1.3;
                  word-break: break-word;
                  margin: -6px 0 6px;
                  letter-spacing: 0.2px;
                "
          >
            {{ selectedEvent.topic || "Untitled Event" }}
          </div>

          <v-layout row wrap align-center style="font-size: 13px;">
            <div
              style="display: flex; align-items: center; margin-right: 18px; opacity: 0.95;"
            >
              <v-icon small dark class="mr-1">mdi-calendar-clock</v-icon>
              <span>
                {{ formatDate(selectedEvent.start) }} ·
                {{ formatTime(selectedEvent.start) }} –
                {{ formatTime(selectedEvent.end) }}
              </span>
            </div>
            <div style="display: flex; align-items: center; opacity: 0.95;">
              <v-icon small dark class="mr-1">mdi-account-circle</v-icon>
              <span>Scheduled by {{ selectedEvent.name }}</span>
            </div>
          </v-layout>
        </div>
      </v-card-title>

      <v-card-text class="pt-3">
        <v-list dense class="py-0">
          <v-list-tile>
            <v-list-tile-content
              ><strong>Created On</strong></v-list-tile-content
            >
            <v-list-tile-content class="align-end"
              >{{ new Date(selectedEvent.createdOn).toLocaleString() }}
              <span class="grey--text caption"
                >By {{ selectedEvent.createdBy }}</span
              ></v-list-tile-content
            >
          </v-list-tile>
          <!-- <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content
                  ><strong>Scheduled By</strong></v-list-tile-content
                >
                <v-list-tile-content class="align-end">{{
                  selectedEvent.name
                }}</v-list-tile-content>
              </v-list-tile> -->
          <v-divider></v-divider>
          <v-list-tile>
            <v-list-tile-content><strong>PIN</strong></v-list-tile-content>
            <v-list-tile-content class="align-end">{{
              selectedEvent.PIN
            }}</v-list-tile-content>
          </v-list-tile>
        </v-list>

        <div
          style="border: 1px solid #ccc; border-radius: 5px; padding: 10px 12px; margin-top: 14px;"
        >
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <v-icon small color="success" class="mr-2"
              >mdi-account-group</v-icon
            >
            <b>Participants</b>
            <span class="grey--text caption ml-2"
              >({{
                (selectedEvent.participants &&
                  selectedEvent.participants.length) ||
                  0
              }})</span
            >
          </div>
          <div
            v-if="
              selectedEvent.participants && selectedEvent.participants.length
            "
          >
            <v-chip
              v-for="(p, i) in selectedEvent.participants"
              :key="i"
              small
              outline
              color="success"
              class="ma-1"
              :title="
                p.username ? 'Internal User' : 'External User'
              "
            >
              <v-icon small left>mdi-account</v-icon>
              {{ p.name }}
            </v-chip>
          </div>
          <div v-else class="caption grey--text">No participants</div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" outline small @click="$emit('close')"
          >Close</v-btn
        >
        <v-btn color="error" outline small @click="$emit('delete')"
          >Delete</v-btn
        >
        <v-btn
          :loading="processing"
          color="warning"
          outline
          small
          @click="$emit('edit')"
          >Edit</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ConferenceRoomBooking",
  props: {
    selectedEvent: Object,
    processing: Boolean,
  },
  methods: {
    formatDate(val) {
      return val ? moment(val).format("MM/DD/YYYY") : "";
    },
    formatTime(val) {
      return val ? moment(val).format("hh:mm A") : "";
    },
  },
};
</script>

<style scoped></style>
